<img class="auth-image auth-image-{{id}}" [src]="id | authImage | async" [alt]="alt"/>
